jQuery(document).ready(function () {
    // Watch And Buy Section Slide JS Start
    jQuery('#thumbnail-slider').slick({
        dots: false,
        infinite: false,
        autoplay: true,
        autoplaySpeed: 4000,
        arrows: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        prevArrow: `<button type="button" class="slick-prev">
                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M12.833 5.5L7.33301 11L12.833 16.5" stroke="#171717" stroke-width="1.375" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </button>`,
        nextArrow: `<button type="button" class="slick-next">
                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M9.16699 5.5L14.667 11L9.16699 16.5" stroke="#171717" stroke-width="1.375" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </button>`,

        responsive: [
            {
                breakpoint: 1025,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    arrows: false,
                    dots: false,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
    // Watch And Buy Section Slide JS End

    function toggleArrows(slick) {
        const currentSlide = slick.currentSlide;
        const slideCount = slick.slideCount;
        const slidesToShow = slick.options.slidesToShow;

        // Disable previous button on the first slide
        if (currentSlide === 0) {
            jQuery('.slick-prev').prop('disabled', true).css({
                "pointer-events": "none",
                "opacity": "0.5",
            });
        } else {
            jQuery('.slick-prev').prop('disabled', false).css({
                "pointer-events": "auto",
                "opacity": "1",
            });
        }

        // Disable next button on the last slide
        if (currentSlide >= slideCount - slidesToShow) {
            jQuery('.slick-next').prop('disabled', true).css({
                "pointer-events": "none",
                "opacity": "0.5",
            });
        } else {
            jQuery('.slick-next').prop('disabled', false).css({
                "pointer-events": "auto",
                "opacity": "1",
            });
        }
    }

    // Initialize slider and set initial state of arrows
    jQuery('#thumbnail-slider').on('init', function (event, slick) {
        toggleArrows(slick);

        // Add one-time click event for slick-prev
        jQuery('.slick-prev').one('click', function () {
            jQuery(this).prop('disabled', true).css({
                "pointer-events": "none",
                "opacity": "0.5",
            });
        });

        // Add one-time click event for slick-next
        jQuery('.slick-next').one('click', function () {
            jQuery(this).prop('disabled', true).css({
                "pointer-events": "none",
                "opacity": "0.5",
            });
        });
    });

    // Update arrows state on slide change
    jQuery('#thumbnail-slider').on('afterChange', function (event, slick, currentSlide) {
        toggleArrows(slick);
    });

});

// Collection card JS for variant Color Start

function updateRecentProducts() {
    document.querySelectorAll('.product-card').forEach(function (card) {

        var firstVariant = card.querySelector('.first-variant');
        var colorSelectedCustom = card.querySelector('.color-selected-custom');
        
        if (firstVariant && colorSelectedCustom) {
            var image_v = document.querySelector('.first-variant').getAttribute('data-img');
            var title_v = firstVariant.getAttribute('data-title');
            colorSelectedCustom.textContent = title_v;

            document.querySelector('.product-card__media img').setAttribute('src', image_v);

        }
    });
}

document.addEventListener('DOMContentLoaded', function () {

    var interval = setInterval(function () {
        if (document.querySelector('.product-card')) {
            updateRecentProducts();
            clearInterval(interval);
        }
    }, 500);

    document.addEventListener('click', function (event) {
        if (event.target.closest('.variant-item-single')) {
            var item = event.target.closest('.variant-item-single');
            var productCard = item.closest('.product-card');

            // Remove class from all variant items within the same product card
            productCard.querySelectorAll('.variant-item-single').forEach(function (el) {
                el.classList.remove('first-variant');
            });

            // Add class to the clicked element
            item.classList.add('first-variant');

            // Get the title and update the color-selected-custom text
            var title_v = item.getAttribute('data-title');
            productCard.querySelector('.color-selected-custom').textContent = title_v;

            // Get the variant ID and update the form elements
            var variant_id = item.getAttribute('data-id');
            var form = productCard.querySelector('.shopify-product-form');
            form.querySelector('button').setAttribute('data-variant-id', variant_id);
            form.querySelector('input[name="id"]').setAttribute('value', variant_id);

            // Get the image and update the image sources
            var image_v = item.getAttribute('data-img');
            var mediaImage = productCard.querySelector('.product-card__media img');
            mediaImage.setAttribute('src', image_v);
            mediaImage.setAttribute('srcset', image_v);
        }
    });
});

// Collection card JS for variant Color End

// Blog Page Sidebar JS Start

jQuery(document).on("click", ".blog-sidebar-open .blog-posts-row overlay-element", function () {
    jQuery("body").removeClass("blog-sidebar-open");
});

jQuery(".sidebar-toogle").click(function () {
    jQuery("body").toggleClass("blog-sidebar-open");
});
jQuery(".close-sidebar").click(function () {
    jQuery("body").removeClass("blog-sidebar-open");
    jQuery('mouse-cursor').hide();
});

// Blog Page Sidebar JS End

// Reset Password Page jQuery Start

jQuery('a[href="#Recover"]').on('click', function (event) {
    $('html, body').animate({
        scrollTop: $('#Recover').offset().top - 100 // Scroll with 100px offset
    }, 500); // 500ms animation duration
});

// Reset Password Page jQuery End




// JS for set add cart button below the title
document.addEventListener('DOMContentLoaded', () => {
    const formWrapper = document.querySelector('.product-form-wrapper');
    const targetDiv = document.querySelector('.product__title.with-price');

    if (formWrapper && targetDiv) {
        if (targetDiv.nextElementSibling !== formWrapper) {
            targetDiv.after(formWrapper);
        } else {
            console.log('Form wrapper is already in the correct position.');
        }
    } else {
        console.log('Error: Required elements not found.');
    }
});

// For sticky buy button click
document.addEventListener('click', function(e) {
    if (e.target.closest('.sticky-buy-button .sticky-buy-button__variant > button.product-buynow')) {
        const targetBtn = document.querySelector('#gokwik-buy-now');
        if (targetBtn) targetBtn.click();
    }
});